import { Button } from '@/components/ui/button';
import { X, HelpCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PopupCoordinates } from './PopupField';
import { capitalizeFirstLetter } from '@/utils/strings';

interface UnknownLayerPopupProps {
	longitude: number;
	latitude: number;
	properties: Record<string, string>;
	layerType: string;
	onClose: () => void;
}

export function UnknownLayerPopup({ longitude, latitude, properties, layerType, onClose }: UnknownLayerPopupProps) {
	return (
		<Card className="bg-white dark:bg-slate-900 border shadow-lg min-w-[250px] max-w-[350px]">
			<CardHeader className="pb-2">
				<div className="flex items-center justify-between">
					<CardTitle className="flex items-center gap-2 text-sm">
						<HelpCircle className="h-4 w-4" />
						Unknown Layer: {layerType}
					</CardTitle>
					<Button variant="ghost" size="icon" onClick={onClose} className="h-6 w-6">
						<X className="h-3 w-3" />
					</Button>
				</div>
			</CardHeader>
			<CardContent className="space-y-3">
				<PopupCoordinates longitude={longitude} latitude={latitude} />

				<div className="text-xs space-y-1">
					{Object.entries(properties).map(([key, value]) => (
						<div key={key} className="flex justify-between">
							<span className="text-slate-600 dark:text-slate-400">{capitalizeFirstLetter(key)}:</span>
							<span>{String(value)}</span>
						</div>
					))}
				</div>
			</CardContent>
		</Card>
	);
}
